export const MILITARY_ROLE_OPTIONS = [
  'siteAdmin',
  'Technician',
  'App Viewer',
  'Expediter',
  'Pro-Super',
  'Management',
  'Commander',
  'Other',
];

export const MILITARY_SHOP_OPTIONS = [
  'AGE',
  'APG',
  'Avionics',
  'Egress',
  'E&E',
  'Engines',
  'A/R',
  'Hydro',
  'Sheet Metal',
  'Metals Tech',
  'Production',
  'Fuels',
  'Munitions',
  'MOC',
  'NDI',
  'QA',
  'POL',
  'Supply',
  'Other',
];

export const AIRCRAFT_STATUS_OPTIONS = [
  '',
  'FMC',
  'GAR',
  'CANN',
  'PMCB',
  'PMCM',
  'PMCS',
  'NMCBU',
  'NMCBS',
  'NMCMU',
  'NMCMS',
  'NMCS',
  'NMCBUA',
  'NMCBSA',
  'NMCMUA',
  'NMCMSA',
  'NMCSA',
];

export const PERSONNEL_RANK_OPTIONS = [
  'CIV',
  'AB',
  'Amn',
  'A1C',
  'SrA',
  'SSgt',
  'TSgt',
  'MSgt',
  'SMSgt',
  'CMSgt',
  '2d Lt',
  '1st Lt',
  'Capt',
  'Maj',
  'Lt Col',
  'Col',
];

export const PERSONNEL_SQUADRON_OPTIONS = [
  'AMXS',
  'MXS',
  'MUNS',
  'MXG',
];

export const PERSONNEL_SKILL_LEVEL_OPTIONS = [
  '0-Level',
  '1-Level',
  '3-Level',
  '5-Level',
  '7-Level',
  '9-Level',
  'Other',
];

export const PERSONNEL_LABOR_CATEGORY_OPTIONS = [
  'CIV',
  'AD',
  'ART',
  'AGR',
  'TR',
  'Activated TR',
  'IMA',
  'Other',
];

export const MDS_OPTIONS = [
  'A010C',
  'B052H',
  'C005M',
  'C017A',
  'C040C',
  'C130H',
  'C130J',
  'F016C',
  'F035A',
  'HC130J',
  'HH060W',
  'KC046A',
  'KC135R',
  'MH139A',
  'WC130J',
];

export const OFFSTATION_LOCATION_MASK = '****';

const US_STATE_NAMES = [
  'Alabama', 'Alaska', 'Arizona', 'Arkansas', 'California', 'Colorado', 'Connecticut', 'Delaware',
  'Florida', 'Georgia', 'Hawaii', 'Idaho', 'Illinois', 'Indiana', 'Iowa', 'Kansas', 'Kentucky',
  'Louisiana', 'Maine', 'Maryland', 'Massachusetts', 'Michigan', 'Minnesota', 'Mississippi',
  'Missouri', 'Montana', 'Nebraska', 'Nevada', 'New Hampshire', 'New Jersey', 'New Mexico',
  'New York', 'North Carolina', 'North Dakota', 'Ohio', 'Oklahoma', 'Oregon', 'Pennsylvania',
  'Rhode Island', 'South Carolina', 'South Dakota', 'Tennessee', 'Texas', 'Utah', 'Vermont',
  'Virginia', 'Washington', 'West Virginia', 'Wisconsin', 'Wyoming',
];

const US_STATE_ABBREVIATIONS = [
  'AL', 'AK', 'AZ', 'AR', 'CA', 'CO', 'CT', 'DE', 'FL', 'GA', 'HI', 'ID', 'IL', 'IN', 'IA',
  'KS', 'KY', 'LA', 'ME', 'MD', 'MA', 'MI', 'MN', 'MS', 'MO', 'MT', 'NE', 'NV', 'NH', 'NJ',
  'NM', 'NY', 'NC', 'ND', 'OH', 'OK', 'OR', 'PA', 'RI', 'SC', 'SD', 'TN', 'TX', 'UT', 'VT',
  'VA', 'WA', 'WV', 'WI', 'WY',
];

//for use in Status tab foreign location-offstation masking
export const LOCATION_DESIGNATOR_MAP = {
  ADL3: { name: 'Al Dhafra', domestic: false },
  AJXF: { name: 'JB Andrews in MD', domestic: true },
  ALDD: { name: 'Prince Sultan AOFG', domestic: false },
  ASPW: { name: 'Avord', domestic: false },
  AWUB: { name: 'Barksdale AFB', domestic: true },
  BGHQ: { name: 'Ben Gurion', domestic: false },
  BPWZ: { name: 'Biggs AAF', domestic: true },
  BAEY: { name: 'Beale AFB in CA', domestic: true },
  CTGC: { name: 'Grissom ARB in IN', domestic: true },
  DDPM: { name: 'Ft Worth NAS (Carswell)', domestic: true },
  DKFX: { name: 'JB Charleston AFB in SC', domestic: true },
  FBNV: { name: 'Davis-Monthan AFB in AZ', domestic: true },
  FGVD: { name: 'DJibouti Ambouli', domestic: false },
  FGWB: { name: 'Dobbins ARB in GA', domestic: true },
  FJXT: { name: 'Dover AFB in DE', domestic: true },
  FHWS: { name: 'Donaldson FLD', domestic: true },
  FKNN: { name: 'Bangor Intl', domestic: true },
  FSPM: { name: 'Edwards AFB in CA', domestic: true },
  FNWZ: { name: 'Dyess AFB in TX', domestic: true },
  FTEV: { name: 'Hurlburt Field in FL', domestic: true },
  FUPL: { name: 'King Faisal', domestic: false },
  FXSB: { name: 'JB Elmendorf-Rich in AK', domestic: true },
  JEGW: { name: 'Gowen Field', domestic: true },
  JLSS: { name: 'Pittsburgh in PA', domestic: true },
  KRSM: { name: 'Hill AFB in UT', domestic: true },
  KYJM: { name: 'Homestead AFB in FL', domestic: true },
  MAHG: { name: 'Keesler AFB in MS', domestic: true },
  MBPF: { name: 'JBSA Lackland (Kelly ANG)', domestic: true },
  KNMJ: { name: 'Hickam', domestic: true },
  KSRM: { name: 'Hillsboro', domestic: true },
  LNDS: { name: 'Israel AFE', domestic: false },
  NKAK: { name: 'Little Rock AFB in AR', domestic: true },
  NUEX: { name: 'Luke AFB in AZ', domestic: true },
  MQNA: { name: 'Lajes', domestic: false },
  NVZR: { name: 'MacDill AFB', domestic: true },
  PCZP: { name: 'March ARB', domestic: true },
  PNQS: { name: 'Maxwell AFB', domestic: true },
  PQWY: { name: 'JBLM McChord', domestic: true },
  PRQE: { name: 'McConnell AFB in KS', domestic: true },
  PTFL: { name: 'JB McGuire', domestic: true },
  QFQE: { name: 'Mildenhall', domestic: false },
  QJKL: { name: 'Minneapolis St Pa', domestic: true },
  QSEU: { name: 'Moody AFB', domestic: true },
  RKMF: { name: 'Nellis AFB in NV', domestic: true },
  RVKQ: { name: 'Niagara Falls', domestic: true },
  SXHT: { name: 'Patrick SFB', domestic: true },
  TDKA: { name: 'Peterson SFB', domestic: true },
  TQGQ: { name: 'Portland Intl', domestic: true },
  TYFW: { name: 'Ramstein', domestic: false },
  UHHZ: { name: 'Robins AFB', domestic: true },
  VDYD: { name: 'Scott AFB', domestic: true },
  VKAG: { name: 'Seymour Johnson', domestic: true },
  VYHK: { name: 'Spangdahlem AB', domestic: false },
  WWYK: { name: 'Tinker AFB DEPOT', domestic: true },
  WWYP: { name: 'Tinker AFB', domestic: true },
  XDAT: { name: 'Travis AFB in CA', domestic: true },
  XHEA: { name: 'Tucson Intl', domestic: true },
  XLWU: { name: 'Tyndall AFB in FL', domestic: true },
  YTPM: { name: 'Westover ARB', domestic: true },
  YWHG: { name: 'Whiteman AFB', domestic: true },
  ZHTV: { name: 'Wright Patterson', domestic: true },
  ZNRL: { name: 'Yokota', domestic: false },
  ZQEL: { name: 'Youngstown Warren', domestic: true },
};

export const BASE_LOCATION_CODE_MAP = {
  'Maxwell Air Force Base': 'PNQS',
  'Davis-Monthan Air Force Base': 'FBNV',
  'Edwards Air Force Base': 'FSPM',
  'March Air Reserve Base': 'PCZP',
  'Peterson Air Force Base': 'TDKA',
  'Homestead Air Reserve Base': 'KYJM',
  'MacDill Air Force Base': 'NVZR',
  'Patrick Air Force Base': 'SXHT',
  'Dobbins Air Reserve Base': 'FGWB',
  'Moody Air Force Base': 'QSEU',
  'Robins Air Force Base': 'UHHZ',
  'Joint Base Pearl Harbor-Hickam': 'KNMJ',
  'Scott Air Force Base': 'VDYD',
  'Grissom Air Reserve Base': 'CTGC',
  'Barksdale Air Force Base': 'AWUB',
  'Joint Base Andrews': 'AJXF',
  'Westover Air Reserve Base': 'YTPM',
  'Minneapolis-St Paul ARS': 'QJKL',
  'Keesler Air Force Base': 'MAHG',
  'Whiteman Air Force Base': 'YWHG',
  'Joint Base McGuire-Dix-Lakehurst': 'PTFL',
  'Niagara Falls ARS': 'RVKQ',
  'Seymour Johnson Air Force Base': 'VKAG',
  'Wright-Patterson Air Force Base': 'ZHTV',
  'Youngstown ARS': 'ZQEL',
  'Tinker Air Force Base': 'WWYP',
  'Pittsburgh ARS': 'JLSS',
  'Joint Base Charleston': 'DKFX',
  'Lackland (Kelly)': 'MBPF',
  'JBSA Lackland (Kelly ANG)': 'MBPF',
  'Hill Air Force Base': 'KRSM',
  'Joint Base Lewis-McChord': 'PQWY',
  'Ramstein Air Base': 'TYFW',
  'Spangdahlem Air Base': 'VYHK',
  'Lajes Field': 'MQNA',
  'Yokota Air Base': 'ZNRL',
  'RAF Mildenhall': 'QFQE',
  'Al Dhafra Air Base': 'ADL3',
  'Prince Sultan AOFG': 'ALDD',
  'Prince Sultan AB': 'ALDD',
  'Avord': 'ASPW',
  'Ben Gurion': 'BGHQ',
  'Biggs AAF': 'BPWZ',
  'Beale Air Force Base': 'BAEY',
  'Beale AFB': 'BAEY',
  'Ft Worth NAS (Carswell)': 'DDPM',
  'Dover Air Force Base': 'FJXT',
  'Dover AFB': 'FJXT',
  'Donaldson FLD': 'FHWS',
  'Bangor Intl': 'FKNN',
  'Dyess Air Force Base': 'FNWZ',
  'Dyess AFB': 'FNWZ',
  'Hurlburt Field': 'FTEV',
  'King Faisal': 'FUPL',
  'Joint Base Elmendorf-Richardson': 'FXSB',
  'Gowen Field': 'JEGW',
  'Hickam': 'KNMJ',
  'Hillsboro': 'KSRM',
  'Israel AFE': 'LNDS',
  'Little Rock AFB': 'NKAK',
  'Little Rock Air Force Base': 'NKAK',
  'Luke Air Force Base': 'NUEX',
  'Luke AFB': 'NUEX',
  'March AFB': 'PCZP',
  'Maxwell AFB': 'PNQS',
  'McConnell Air Force Base': 'PRQE',
  'McConnell AFB': 'PRQE',
  'Nellis Air Force Base': 'RKMF',
  'Nellis AFB': 'RKMF',
  'Patrick SFB': 'SXHT',
  'Peterson SFB': 'TDKA',
  'Portland Intl': 'TQGQ',
  'Robins AFB': 'UHHZ',
  'Scott AFB': 'VDYD',
  'Spangdahlem AB': 'VYHK',
  'Tinker': 'WWYP',
  'Tinker AFB': 'WWYP',
  'Travis Air Force Base': 'XDAT',
  'Travis AFB': 'XDAT',
  'Tucson Intl': 'XHEA',
  'Tyndall Air Force Base': 'XLWU',
  'Tyndall AFB': 'XLWU',
  'Westover ARB': 'YTPM',
  'Whiteman AFB': 'YWHG',
  'Wright Patterson': 'ZHTV',
  'Yokota': 'ZNRL',
  'Youngstown Warren': 'ZQEL',
};

function cleanLocationKey(value) {
  return String(value || '').trim().replace(/\s+/g, ' ');
}

function offstationCodeTokens(value) {
  return String(value || '').toUpperCase().match(/[A-Z0-9]{4,}/g) || [];
}

function hasUsStateMarker(value) {
  const text = ` ${String(value || '').toUpperCase().replace(/[^A-Z0-9]+/g, ' ')} `;
  const hasStateName = US_STATE_NAMES.some(state => text.includes(` ${state.toUpperCase()} `));
  const hasStateAbbreviation = US_STATE_ABBREVIATIONS.some(state => text.includes(` ${state} `));
  return hasStateName || hasStateAbbreviation || text.includes(' USA ') || text.includes(' UNITED STATES ');
}

function isKnownUsDomesticBase(value) {
  const normalized = cleanLocationKey(value).toLowerCase();
  if (!normalized) return false;
  return Object.values(LOCATION_DESIGNATOR_MAP)
    .filter(row => row.domestic && row.name)
    .some(row => normalized.includes(row.name.toLowerCase()));
}

export function canShowOffstationLocation(value) {
  const tokens = offstationCodeTokens(value);
  return (
    tokens.some(token => Boolean(LOCATION_DESIGNATOR_MAP[token]?.domestic)) ||
    isKnownUsDomesticBase(value) ||
    hasUsStateMarker(value)
  );
}

export function maskOffstationLocation(value, emptyLabel = 'Offstation location needed') {
  if (!cleanLocationKey(value)) return emptyLabel;
  return canShowOffstationLocation(value) ? value : OFFSTATION_LOCATION_MASK;
}

export function isOffstationLocationMasked(value) {
  return Boolean(cleanLocationKey(value) && !canShowOffstationLocation(value));
}

export function getBaseLocationCode(baseName) {
  const normalized = cleanLocationKey(baseName);
  if (!normalized) return '';
  if (BASE_LOCATION_CODE_MAP[normalized]) return BASE_LOCATION_CODE_MAP[normalized];
  const matchedKey = Object.keys(BASE_LOCATION_CODE_MAP).find(key => key.toLowerCase() === normalized.toLowerCase());
  if (matchedKey) return BASE_LOCATION_CODE_MAP[matchedKey];
  const matchedDesignator = Object.entries(LOCATION_DESIGNATOR_MAP).find(([, value]) => (
    cleanLocationKey(value?.name).toLowerCase() === normalized.toLowerCase()
  ));
  return matchedDesignator ? matchedDesignator[0] : '';
}

export function formatBaseLocationWithCode(baseName) {
  const base = cleanLocationKey(baseName);
  const code = getBaseLocationCode(base);
  return code ? `${code} | ${base}` : base;
}
